import React from "react";
import PropTypes from "prop-types";
import { ImageCard } from "../EngagementSectionV2/CompanyInitiative/styles";
import { connect } from "react-redux";
import { ImageUrl } from "../../utils/constants";
import { CloseIconBranding, AdminDownloadIcon } from "../../utils/icons";
import {CommonButtonBorder} from '../common/commonStyles'
import { fetchApi, getInitials } from "../../utils/methods";
import { toast } from "react-toastify";
import { GetInitiativeParticipants, GetInitiativeReport } from "../../redux/constants/apiConstants";
import CSVList from "../AttendeesModal/CSVList";
import moment from "moment";
import {HeaderPopup, StyledModal, StyledModalBody, ParticipantsHeader, ScrollWrapper, ParticipantCard} from './styles'
// import SkeletonLoder from "../common/skeletonLoder";
import { NameInitials } from "../Manager/styles";

class CompanyInitiative extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initiative: null,
      printCSV:false,
      isloading:false,
      initiativeReportData:[],
      initiativeCsvData:[],
      headers:[
        { label: "Name", key: "user_name" },
        { label: "Email", key: "mail" },
        { label: "Completed On", key: "date" },
      ],
      page: 1,
      limit:7,
      initiativeUsers:[]
    };
  }
  componentDidMount() {
    this.props.companyId && this.getInitiativeDetail();
  }

  getInitiativeDetail = async () => {
    try {
      const { companyId, detailInitiative } = this.props;
      const { page, limit } = this.state;
      const startDate = detailInitiative?.start_date
      const endDate = detailInitiative?.end_date
      const postData = {
        company_id: companyId,
        // initiative_id: detailInitiative.id,
        company_initiative_id: detailInitiative.company_initiative_id,
        start_date: startDate,
        end_date: endDate,
        page: page,
        limit: limit
      }; 
      const res = await fetchApi(
        GetInitiativeParticipants+"/"+companyId,
        "POST",
        postData,
        {},
        this.successFunc
      );
      if (res.message) {
        toast.error(res.message);
      }
      if(page===1){
        this.setState({ initiative: res.data, initiativeUsers : res.data.users});
      }else{
        this.setState({ initiative: res.data, initiativeUsers : [...this.state.initiativeUsers, ...res.data.users]});
      }

    } catch (error) {
      toast.error(error.message);
    }
  };

  getInitiativesReport = async () => {
    try {
      const { companyId, detailInitiative } = this.props;
      const startDate = detailInitiative?.start_date
      const endDate = detailInitiative?.end_date
      const postData = {
        company_id: companyId,
        // initiative_id: detailInitiative.id,
        company_initiative_id: detailInitiative.company_initiative_id,
        start_date: startDate,
        end_date: endDate,
      }; 
      const res = await fetchApi(
        GetInitiativeParticipants+"/"+companyId,
        "POST",
        postData,
        {},
        this.successFunc
      );
      if (res.message) {
        toast.error(res.message);
      }
      this.setState({ initiativeCsvData: res.data.users }, () => {
        this.setState({ printCSV: true });
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  getInitiativeReport = async () => {
    try {
      const { companyId, detailInitiative } = this.props;
      // const startDate = moment(detailInitiative?.start_date).format('YYYY-MM-DD');
      // const endDate = moment(detailInitiative?.end_date).format('YYYY-MM-DD');
      const res = await fetchApi(
        `${GetInitiativeReport}/${companyId}/${detailInitiative.company_initiative_id}`,
        "GET",
        null,
        {},
        this.successFunc
      );
      if (res.message) {
        toast.error(res.message);
      }
      this.setState({ initiativeReportData: res.data }, () => {
        this.setState({ printCSV: true });
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  printCsv = () => {
    this.setState({ 
      printCSV: true
    });
  }

  downloadEnrolledList = (bool) => {
    this.setState({
      printCSV: bool,
      isloading: bool
    })
  };

  onScrollMonth = (e) => {
    const diff=Math.round(e.target.scrollHeight - e.target.scrollTop) - Math.round(e.target.clientHeight)
    const isBottom = Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1)||Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight);
    if (
      (isBottom||diff===1) && this.state.initiativeUsers?.length < this.state.initiative?.total
    ) {
      this.setState({
        page:this.state.page+1
      },()=>this.getInitiativeDetail()) 
    }
  };

  render() {
    const { showModal, onClose, detailInitiative } = this.props;
    const {initiative, initiativeUsers} = this.state;

    return (
      initiative?.users&&<StyledModal
        transform={1}
        show={showModal}
        newWidth={"432px"}
        newBg={"newBg"}
        height="50px"
        display="none"
        onHide={() => onClose()}
      >
        <HeaderPopup>
          <div className="title">Initiative Info</div>
          <div className="closeIcon" onClick={() => onClose()}>
            {CloseIconBranding()}
          </div>
        </HeaderPopup>
        <div className="border-top"/>
        <StyledModalBody>
          <ParticipantsHeader>
            <ImageCard margin="auto 0 auto 8px" width bgColor={detailInitiative?.color}>
              <img src={ImageUrl + "/" + detailInitiative?.initiative_white_icon} />
            </ImageCard>
            <div className="initiative-wrap">
              <div className="initiative">{detailInitiative?.initiative_name}</div>
              <div className="completed">Employees who completed</div>
              <div className="date">{moment(new Date(detailInitiative?.start_date)).format("MMM DD YYYY") } - {moment(new Date(detailInitiative?.end_date)).format("MMM DD YYYY") }</div>
            </div>
            <div className="count">{initiative?.total}</div>
          </ParticipantsHeader>
          <ScrollWrapper height={initiative?.total>6?"404px":""} scroll={initiativeUsers?.length>6?1:0} onScroll={(e)=>this.onScrollMonth(e)}>
            {initiativeUsers?.map((name, index)=>
              (<ParticipantCard key={index}>
                {name?.profile_image !== "profile-Image/default.png"?<div className="profile">
                  <img src={ImageUrl+"/"+ name?.profile_image}/>
                </div>:
                  <NameInitials id="name-initials" margin="0 12px 0 0">
                    {getInitials(name?.user_name)}
                  </NameInitials> 
                }
                <div className="name">{name?.user_name}</div>
                <div className="date">{moment(new Date(name?.date)).format("MMM DD") }</div>
              </ParticipantCard>)
            )}
          </ScrollWrapper>
          {initiative?.total>0&&<div className="button-wrapper">
            <CommonButtonBorder width="200px" height='40px' margin="16px 0 0 0" onClick={()=>this.getInitiativesReport()}>
              {AdminDownloadIcon()}
              Print Info
            </CommonButtonBorder>
          </div>}
        </StyledModalBody>
        {this.state.printCSV &&
          <CSVList
            Title={`Initiative Participants Report`}
            removeCSVData={()=>this.setState({printCSV:false})}
            headers={this.state.headers}
            data={this.state.initiativeCsvData}
          />
        }
      </StyledModal>
    );
  }
}
CompanyInitiative.propTypes = {
  showModal: PropTypes.bool.isRequired,
  companyPopup: PropTypes.func,
  onClose: PropTypes.func,
  detailInitiative: PropTypes.object,
  companyId: PropTypes.number,
  history: PropTypes.object,
  userId:PropTypes.number,
  setPage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
})

export default connect(mapStateToProps, null)(CompanyInitiative);
